<template>
	<header class="calc_header">
		<div class="con-1440">
			<h1 class="header__title">{{ header }}</h1>
		</div>
	</header>
</template>

<script>

import CampaignHelper from '@/helpers/campaignHelper';

export default {
    data() {
        return {
            header: 'Minősített fogyasztóbarát lakásbiztosítás kalkulátor',
        };
    },
    created() {
        if (CampaignHelper.isItHomeInsuranceCampaign()) {
            this.header = 'Lakásbiztosítási kampány szerinti díjkalkuláció';
        }
    },
    methods: { },
};
</script>
